import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9eeff7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexBox" }
const _hoisted_2 = {
  class: "w1200",
  style: {"margin":"0 auto"}
}
const _hoisted_3 = { class: "banner-wrapper" }
const _hoisted_4 = { class: "banner_menu" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner_menu_top" }, "全部产品分类", -1))
const _hoisted_6 = { class: "banner_menu_list" }
const _hoisted_7 = { class: "banner_menu_left" }
const _hoisted_8 = { class: "title_box" }
const _hoisted_9 = { class: "icon_box" }
const _hoisted_10 = { class: "banner_menu_right" }
const _hoisted_11 = { class: "classTips" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  style: {"width":"77px"}
}
const _hoisted_14 = { href: "javascript:;" }
const _hoisted_15 = { class: "banner" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "userInfo" }
const _hoisted_18 = { class: "userInfoBox" }
const _hoisted_19 = { class: "user_info" }
const _hoisted_20 = { class: "avatar" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { style: {"margin-top":"10px"} }
const _hoisted_26 = {
  key: 0,
  style: {"text-align":"center","margin-top":"10px"}
}
const _hoisted_27 = { class: "vip_article_cat" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "公告")
], -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "backup_festival" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tis" }, "我的资料", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tis" }, "我的订单", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tis" }, "收货地址", -1))
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tis" }, "购物车", -1))
const _hoisted_37 = ["href"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tis" }, "客服QQ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tis" }, "帮助中心", -1))
const _hoisted_40 = { class: "prolist" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "proImg" }
const _hoisted_43 = {
  class: "image-slot",
  style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%","height":"100%","font-size":"30px"}
}
const _hoisted_44 = { class: "proName" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div style=\"background-color:#fff;padding:20px 0;\" data-v-a9eeff7b><div class=\"Ordering_process\" style=\"width:1200px;margin:0 auto;\" data-v-a9eeff7b><div class=\"liucheng_l\" data-v-a9eeff7b>下单流程</div><div class=\"liucheng_r\" data-v-a9eeff7b><ul data-v-a9eeff7b><li data-v-a9eeff7b><div class=\"liucheng_b\" data-v-a9eeff7b><div class=\"liucheng_num\" data-v-a9eeff7b>01</div><div class=\"liucheng_t\" data-v-a9eeff7b>自助报价</div></div></li><li data-v-a9eeff7b><div class=\"liucheng_b\" data-v-a9eeff7b><div class=\"liucheng_num\" data-v-a9eeff7b>02</div><div class=\"liucheng_t\" data-v-a9eeff7b>在线下单</div></div></li><li data-v-a9eeff7b><div class=\"liucheng_b\" data-v-a9eeff7b><div class=\"liucheng_num\" data-v-a9eeff7b>03</div><div class=\"liucheng_t\" data-v-a9eeff7b>上传文件</div></div></li><li data-v-a9eeff7b><div class=\"liucheng_b\" data-v-a9eeff7b><div class=\"liucheng_num\" data-v-a9eeff7b>04</div><div class=\"liucheng_t\" data-v-a9eeff7b>到款生产</div></div></li><li data-v-a9eeff7b><div class=\"liucheng_b\" data-v-a9eeff7b><div class=\"liucheng_num\" data-v-a9eeff7b>05</div><div class=\"liucheng_t\" data-v-a9eeff7b>仓配物流</div></div></li></ul></div></div></div>", 1)

import { Picture,Avatar,UserFilled,ArrowRightBold } from '@element-plus/icons-vue';
import { getUserInfo,removeUserInfo } from '@/utils/auth';
import service, { get, post } from '@/utils/request';
import sliderService from '@/api/slider-service';
import bjprojectService from '@/api/bjproject-service';
import productClassService from '@/api/productClass-service';
import articleService from '@/api/article-service';
import router from '@/router';
import { useConfigStore } from '@/store';

//引入图片
import repair_Img from '@/assets/images/repair.png';
import order_Img from '@/assets/images/order.png';
import record_Img from '@/assets/images/record.png';
import settled_Img from '@/assets/images/settled.png';
import tecentqq_Img from '@/assets/images/tecentqq.png';
import collection_Img from '@/assets/images/collection.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const configStore = useConfigStore();

// 基础路径
const baseURL = service.defaults.baseURL;

//用户信息
const userInfo = (getUserInfo() != null ? JSON.parse(String(getUserInfo())) : {});



//轮播图列表
const sliderList = reactive<any[]>([]);

//报价项目分类列表
const treeData = reactive<any[]>([]);

//文章分类列表
const articleCategoryList = reactive<any[]>([]);

//产品分类列表
const productTree = reactive<any[]>([]);




//获取轮播图
const getsliderAll = () => {
    sliderService.all().then((res:any) => {
        if(res.state === 'ok'){
            sliderList.splice(0,sliderList.length);
            sliderList.push(...res.data);
        }
    })
};


//获取报价分类
const getTree = () => {
    bjprojectService.tree().then((res) => {
        if(res.state === 'ok'){
            treeData.splice(0,treeData.length);
            treeData.push(...res.data);
        }
    })
};


//获取文章分类
const getarticleCategory = () => {
    articleService.articleCategory().then((res) => {
        if(res.state === 'ok'){
            const filteredData = res.data.filter((item:any) => item.id === 2);
            articleCategoryList.splice(0,articleCategoryList.length);
            articleCategoryList.push(...filteredData[0].articles);
        }
    })
};


//获取产品分类
const getproductTree = () => {
    productClassService.tree().then((res) => {
        if(res.state === 'ok'){
            productTree.splice(0,productTree.length);
            productTree.push(...res.data);
        }
    })
};


//跳转
const jumpPath = (path:string,mode:string) => {
    if(path.includes('http')){  //跳转外网地址
        window.open(path, `${mode ? mode : '_blank'}`);
    }else{  //跳转内部地址（路由）
        if(mode == '_blank'){
            const routeUrl = router.resolve({ path: path });
            window.open(routeUrl.href, '_blank');
        }else{
            router.push(`${path}`);
        }
    }
};

//产品分类跳转
const jumpPathproductTree = (obj:any) => {
    console.log(obj);
    let url = obj.path;   //跳转路径
    if(url){
        if(url.includes('http')){  //跳转外网地址
            window.open(url, '_blank');
        }else{  //跳转内部地址（路由）
            router.push(`${url}`);
        }
    }
};


//初始化
onMounted( async () => {
    await getproductTree();
    await getTree();
    await getsliderAll();
    await getarticleCategory();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productTree), (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowRightBold))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childrens, (item2, index2) => {
                      return (_openBlock(), _createElementBlock("li", { key: index2 }, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item2.name), 1),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.childrens, (item3, index3) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index3,
                              onClick: () => jumpPathproductTree(item3)
                            }, [
                              (item3.imgUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_el_image, {
                                      class: "img",
                                      src: `${_unref(baseURL)}${item3.imgUrl}`
                                    }, null, 8, ["src"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("a", _hoisted_14, _toDisplayString(item3.name), 1)
                            ], 8, _hoisted_12))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_unref(sliderList).length > 0)
            ? (_openBlock(), _createBlock(_component_el_carousel, {
                key: 0,
                height: "420px"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sliderList), (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                      default: _withCtx(() => [
                        (item.jumpPath)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "javascript:;",
                              onClick: () => jumpPath(item.jumpPath,item.jumpMode)
                            }, [
                              _createVNode(_component_el_image, {
                                src: `${_unref(baseURL)}${item.imgUrl}`
                              }, null, 8, ["src"])
                            ], 8, _hoisted_16))
                          : (_openBlock(), _createBlock(_component_el_image, {
                              key: 1,
                              src: `${_unref(baseURL)}${item.imgUrl}`
                            }, null, 8, ["src"]))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_avatar, {
                  icon: _unref(UserFilled),
                  size: 80,
                  src: _unref(userInfo).wxHeadpic
                }, null, 8, ["icon", "src"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_unref(getUserInfo)())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Hi，" + _toDisplayString(_unref(userInfo).company), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_24, "Hi，欢迎光临")),
                  _createElementVNode("div", _hoisted_25, "欢迎来到" + _toDisplayString(_unref(configStore).config.websiteName), 1)
                ])
              ])
            ]),
            (!_unref(getUserInfo)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[0] || (_cache[0] = () => _unref(router).push('/login')),
                    style: {"background-color":"#CF3A2B","display":"inline-block","color":"#fff","text-decoration":"none","margin-right":"10px","font-size":"14px","height":"30px","line-height":"30px","width":"90px","border":"1px solid #CF3A2B"}
                  }, "登录"),
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[1] || (_cache[1] = () => _unref(router).push('/register')),
                    style: {"border":"1px solid #CF3A2B","text-decoration":"none","color":"#CF3A2B","font-size":"14px","height":"30px","line-height":"30px","display":"inline-block","width":"90px"}
                  }, "注册")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleCategoryList), (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: () => _unref(router).push(`/Servers/${item.id}`)
                    }, "·" + _toDisplayString(item.Title), 9, _hoisted_29)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = () => _unref(router).push('/user/setting')),
                  href: "javascript:;",
                  class: "col"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(`background: url(${_unref(repair_Img)});background-size: 32px;`)
                    }, null, 4)
                  ]),
                  _hoisted_32
                ]),
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = () => _unref(router).push('/user/order')),
                  href: "javascript:;",
                  class: "col"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(`background: url(${_unref(order_Img)});background-size: 32px;`)
                    }, null, 4)
                  ]),
                  _hoisted_33
                ]),
                _createElementVNode("a", {
                  onClick: _cache[4] || (_cache[4] = () => _unref(router).push('/user/shopAddress')),
                  href: "javascript:;",
                  class: "col"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(`background: url(${_unref(record_Img)});background-size: 32px;`)
                    }, null, 4)
                  ]),
                  _hoisted_34
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("a", {
                  onClick: _cache[5] || (_cache[5] = () => _unref(router).push('/shopcart')),
                  href: "javascript:;",
                  class: "col"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(`background: url(${_unref(settled_Img)});background-size: 32px;`)
                    }, null, 4)
                  ]),
                  _hoisted_36
                ]),
                _createElementVNode("a", {
                  href: `http://wpa.qq.com/msgrd?v=3&uin=${_unref(configStore).config.servQq}&site=qq&menu=yes`,
                  target: "_blank",
                  class: "col"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(`background: url(${_unref(tecentqq_Img)});background-size: 32px;`)
                    }, null, 4)
                  ]),
                  _hoisted_38
                ], 8, _hoisted_37),
                _createElementVNode("a", {
                  onClick: _cache[6] || (_cache[6] = () => _unref(router).push('/Servers')),
                  href: "javascript:;",
                  class: "col"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(`background: url(${_unref(collection_Img)});background-size: 32px;`)
                    }, null, 4)
                  ]),
                  _hoisted_39
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(treeData), (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: () => _unref(router).push(`/quoteitem/${item.id}`)
              }, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_el_image, {
                    src: `${_unref(baseURL)}${item.imageSmall}`,
                    style: {"width":"128px","height":"128px","border-radius":"10px"}
                  }, {
                    error: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_el_icon, {
                          style: {"flex":"1","font-size":"30px"},
                          color: "#ccc"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Picture))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 2
                  }, 1032, ["src"])
                ]),
                _createElementVNode("div", _hoisted_44, _toDisplayString(item.name) + "报价", 1)
              ], 8, _hoisted_41)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_45
  ]))
}
}

})